import { Button } from "@/components/ui/button";

import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { SelectCrmSystemSanitizedCombobox } from '@/features/crm_system/components/molecules/SelectCrmSystemSanitizedCombobox';
import { zodResolver } from '@hookform/resolvers/zod';
import { Info } from 'lucide-react';
import { useForm } from "react-hook-form";
import { z } from 'zod';

type Props = {
    defaultData: { name: string; system: string };
    onNext: (data: { name: string, system: string }) => void;
    onBack: () => void;
    onClose: () => void;
}

const Step2: React.FC<Props> = ({
    defaultData,
    onNext,
    onBack,
    onClose,
}) => {
    const schema = z.object({
        name: z.string().min(1, 'Field is required'),
        system: z.string().min(1, 'Field is required'),
    });

    type inputFields = z.infer<typeof schema>;
    const form = useForm<inputFields>({
        resolver: zodResolver(schema),
        defaultValues: defaultData ? defaultData : { name: '', system: '' }
    });

    return (
        <>
            {form.watch("system") === 'airtable' && (
                <div className="flex items-center my-2 text-blue-600">
                    <Info className="flex-shrink-0 me-1" size="16" />
                    <p className="text-xs">Airtable Parameters are defined based on a particular workspace. A workspace has a unique API key and base id. Please enter the associated parameters to your Airtable workspace.</p>
                </div>
            )}
            <form>
                <Form {...form}>
                    <div className="flex flex-col gap-3">
                        <FormField
                            control={form.control}
                            name="system"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>CRM System</FormLabel>
                                    <FormControl>
                                        <SelectCrmSystemSanitizedCombobox
                                            selectedValue={field.value}
                                            setSelectedValue={field.onChange}
                                            mode='single'
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="name"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>CRM Name</FormLabel>
                                    <FormControl>
                                        <Input value={field.value} onChange={field.onChange} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                    </div>
                    <div className="flex items-stretch justify-between w-full pt-3 m-0 mt-3 border-t sm:space-x-2 max-sm:flex-col max-sm:space-y-2">
                        <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>

                        <div className="flex m-0 sm:space-x-2 max-sm:flex-col max-sm:space-y-2">
                            <Button type="button" variant="secondary" onClick={onBack}>Back</Button>
                            <Button type="button" disabled={!form.formState.isValid} onClick={form.handleSubmit(onNext)}>Next</Button>
                        </div>
                    </div>
                </Form>
            </form>
        </>
    )
}

export { Step2 };

